export default {
    he: {
        name: "עברית"
    },
    en: {
        name: "English"
    }
}